import React from "react";
import { removeItems } from "../../slice/cartSlice";
import { ShoppingCart, Trash2, X } from "lucide-react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PageLoader } from "../../helpers/Loader";
export default function Cart({ setShowCart, cart, handleCheckout, loading }) {
  const dispatch = useDispatch();
  const subtotal = cart
    ?.reduce((total, item) => total + item?.price * item?.quantity, 0)
    .toFixed(2);
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/shop");
  };
  return (
    <div className="position-absolute top-0 end-0 w-100 h-100 font-Outfit text-dark bg-dark bg-opacity-75 d-flex align-items-center justify-content-end z-50 backdrop-blur-sm transition-all duration-300">
      <div className="bg-white w-100 w-md-2/5 h-100 d-flex flex-column container border-start shadow-lg">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom sticky-top bg-white">
          <h2 className="text-2xl font-semibold m-0">Your Cart</h2>
          <button
            onClick={() => setShowCart(false)}
            className="btn btn-sm btn-outline-secondary rounded-circle py-2 transition-all hover:bg-gray-200"
            aria-label="Close cart"
          >
            <X size={20} />
          </button>
        </div>

        {/* Scrollable products container */}
        <div className="overflow-auto flex-grow-1 p-2 ">
          {loading ? (
            <PageLoader message="Loading cart..." />
          ) : cart?.length === 0 ? (
            <div className="d-flex flex-column align-items-center justify-content-center h-100 p-4">
              <ShoppingCart
                size={64}
                className="text-muted my-4 animate-bounce"
              />
              <p className="fs-4 fw-semibold text-muted">Your cart is empty</p>
              <button
                onClick={() => {
                  setShowCart(false);
                  handleNavigate();
                }}
                className="btn btn-outline-dark mt-3 transition-all hover:bg-gray-800 hover:text-white"
              >
                Continue Shopping
              </button>
            </div>
          ) : (
            cart?.map((item) => (
              <div
                key={`${item?._id}`}
                className="d-flex justify-content-between border border-gray-200 rounded-lg my-2 p-3 transition-all hover:shadow-md bg-white"
              >
                <div className="d-flex justify-start gap-3">
                  <div className="rounded-md overflow-hidden">
                    <img
                      src={item?.image1 || "/placeholder.svg"}
                      alt={item?.name}
                      width={100}
                      height={100}
                      className="w-24 h-24 object-cover"
                    />
                  </div>
                  <div className="d-flex flex-column justify-content-between">
                    <h3 className="fw-semibold fs-6 ">{item?.name}</h3>
                    <p className="fw-bold ">
                      &#8377;{(item?.price).toFixed(2)} X {item?.quantity} ={" "}
                      {(item?.price * item?.quantity).toFixed(2)}
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <button
                    onClick={() => dispatch(removeItems(item))}
                    className="btn btn-sm btn-outline-danger rounded-circle py-2 transition-transform hover:scale-110"
                    aria-label="Remove item"
                  >
                    <Trash2 size={18} />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Fixed checkout section */}
        <div className="p-3 border-top bg-light mt-auto">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="fs-4 fw-bold">&#8377;{subtotal}</span>
            <span className="fs-5 fw-semibold">
              {" "}
              <button
                className="btn btn-dark w-100 py-3 fw-semibold rounded-pill transition-all hover:opacity-90"
                disabled={cart?.length === 0}
                onClick={handleCheckout}
              >
                CHECKOUT NOW
              </button>
            </span>
          </div>
        </div>
        {/* <ToastContainer position="top-right" autoClose={3000} /> */}
      </div>
    </div>
  );
}
